@if(this.isFetching){
    <div class="bloc_loading">
        <ion-spinner></ion-spinner>
    </div>        
}
@else {    
    @if(this.reportQuota){
    
        <div id="content_quota_chart">
            <!--
            <marv-button class="quota_download" icon="download-outline" [rounded]="true" [isFetching]="this.isFetchingDownload" (click)="this.downloadReport()" />
            -->
            <div id="quota_chart">
                @if(this.chartQuotasOptions){
                    <apx-chart
                        [chart]="this.chartQuotasOptions.chart"
                        [series]="this.chartQuotasOptions.series"
                        [plotOptions]="this.chartQuotasOptions.plotOptions"
                        [dataLabels]="this.chartQuotasOptions.dataLabels"
                        [xaxis]="this.chartQuotasOptions.xaxis"
                        [yaxis]="this.chartQuotasOptions.yaxis"
                        [title]="this.chartQuotasOptions.title"
                        [fill]="this.chartQuotasOptions.fill"
                        [legend]="this.chartQuotasOptions.legend"
                    ></apx-chart>
                }
            </div>        
        </div>
    
        <div class="content_quota">
            
            <div class="content_quota_header"> 
                
                <form [formGroup]="this.displayAsDaysForm">
                     <marv-toggle label="{{'DISPLAY_IN_DAYS' | translate}}" formName="displayAsDays"/>
                </form>
                
                <div class="quota_infos header">
                    <div class="quota_info">
                        <div class="quota_label">{{'QUOTA_GLOBAL' | translate}}</div>
                        <div class="quota_value">{{this.getQuotaValue(this.reportQuota.globalQuota) | number: '1.0-2'}}</div>
                    </div>
                    <div class="quota_info">
                        <div class="quota_label">{{'QUOTA_CONSUMED' | translate}}</div>
                        <div class="quota_value">{{this.getQuotaValue(this.reportQuota.consumedQuota) | number: '1.0-2'}}</div>
                    </div>
                    <div class="quota_info">
                        <div class="quota_label">{{'BALANCE' | translate}}</div>
                        <div class="quota_value">{{this.getQuotaValue(this.reportQuota.globalQuota - this.reportQuota.consumedQuota) | number: '1.0-2'}}</div>
                    </div>
                </div> 
            </div>
                          
        </div>
        
        @if(this.reportQuota.unassignedWorkTimePerMission != null && this.reportQuota.unassignedWorkTimePerMission > 0){
            <div class="quota_not_assigned_sector">
                <div>(*) {{'NOT_ASSIGNED_SECTOR' | translate}}</div>
                <div>{{this.getQuotaValue(this.reportQuota.unassignedWorkTimePerMission) | number: '1.0-2'}}</div>
            </div>
        }
    
    }
    @else{
        <marv-message type="info">{{'MSG_NO_QUOTA' | translate}}</marv-message>
    }
}
